import { render, staticRenderFns } from "./Timecards.vue?vue&type=template&id=06b803ca&lang=pug"
import script from "./Timecards.vue?vue&type=script&lang=js"
export * from "./Timecards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports